import React from 'react';

import moment from 'moment';

import { Link } from 'react-router';

function renderActions(_, { row }) {
	return (
		<div>
			<Link
				className='banners-edit-icon'
				to={`/blog/article-tags/${row.id}/editor`}
			/>
		</div>
	);
}

export default [
	[
		{
			index: 'id',
			header: {
				title: 'ID'
			},
			column: {}
		},
		{
			index: 'created_at',
			header: {
				title: 'created at'
			},
			column: {
				format: v => moment(v).format('DD.MM.YYYY HH:mm')
			}
		},
		{
			index: 'name',
			header: {
				title: 'name'
			},
			column: {}
		},
		{
			index: 'actions',
			header: {
				title: 'actions'
			},
			column: {
				render: renderActions
			}
		}
	]
];


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/blog/article-tag/list/table-initial-data.js